
///////////////////////////////////////////////////////////
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
/*

Migration doc note: “Install @ng-bootstrap/ng-bootstrap@9.1.1 for Angular 12 compatibility. Add NgbModule to AppModule.imports.”

Best practice: Always match ng-bootstrap version to Angular major version.

Future-proofing: For Angular 13+, upgrade to @ng-bootstrap/ng-bootstrap@10.x.x.

👉 In short: Run npm install @ng-bootstrap/ng-bootstrap@9.1.1 and import NgbModule in your app module. That sets up Bootstrap components for Angular 12.


*/

////////////////////////////////////////////////////////////
import { UserService } from './services/user.service';
import { BrowserModule } from '@angular/platform-browser';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';


import { AppComponent } from './app.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { HomeComponent } from './components/home/home.component';

import { AllUsersComponent } from './components/all-users/all-users.component';

import { LoginComponent } from './components/login/login.component';

import { AuthGuard } from './guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { ErrorInterceptorService } from './services/error-interceptor.service';
import { AuthService } from './services/auth.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//import { UserIdleModule } from 'angular-user-idle';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule, Routes } from '@angular/router';
//import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
/////////
// Import your library

/* Angular material */

//import {
 //   MatTabsModule, MatListModule, MatSelectModule, MatInputModule, MatButtonModule, MatDialogModule
//} from '@angular/material';

import { AdminDialogComponent } from './components/admin-dialog/admin-dialog.component';

import { TeacherGuard } from './guards/teacher.guard';


//Idle Session Management Package



import { SideNavComponent } from './components/side-nav/side-nav.component';
//import { StripeModule } from "stripe-angular";
import { NgxStripeModule } from 'ngx-stripe';
import { ManagerGuard } from './guards/manager.guard';
import { AdminSideComponent } from './components/admin-side/admin-side.component';
import { UserSideComponent } from './components/user-side/user-side.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ManagerSideComponent } from './components/manager-side/manager-side.component';
import { ProgressGuard } from './guards/progress.guard';
import { YesNoComponent } from './components/yes-no/yes-no.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
//import { UserIdleModule } from 'angular-user-idle';




import { FullCalendarModule } from '@fullcalendar/angular'; // must come first
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

// Register plugins ONCE here


FullCalendarModule.registerPlugins([
  dayGridPlugin,
  interactionPlugin
]);


// Idle Session management Package

/////////


@NgModule({

  imports: [
    NgbModule,   //further need to explain what that it actually does
    MatTabsModule,
    BrowserModule,
    ReactiveFormsModule,   // ✅ Required
    MatListModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatSliderModule,
    MatRadioModule,
    MatMenuModule,
    MatIconModule,
    MatToolbarModule,
    MatDividerModule,
    MatBadgeModule,
    HttpClientModule,
    //FontAwesomeModule,
    BrowserAnimationsModule,
    FullCalendarModule,   // import here so submodules can also use it
    RouterModule.forRoot([

      // { path: '', redirectTo: '/login', pathMatch: 'full' },
     // { path: '', component: LoginComponent, pathMatch: 'full' },

      { path: 'addusers', loadChildren: () => import('./add-users/add-users.module').then(m => m.AddUsersModule) },

      { path: 'all-users', component: AllUsersComponent, canActivate: [AdminGuard] },

      { path: 'login', component: LoginComponent, data: { animation: 'isRight' } },

      { path: 'manager', loadChildren: () => import('./manager/manager.module').then(m => m.ManagerModule), canActivate: [ManagerGuard] },

      //    { path: 'manager', loadChildren: () => import('./manager/manager.module').then(m => m.ManagerModule), canActivate: [AuthGuard]  },

      { path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule), canActivate: [AuthGuard] },

      { path: 'teacher', loadChildren: () => import('./teacher/teacher.module').then(m => m.TeacherModule), canActivate: [TeacherGuard] },

      { path: 'adminhome', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule), data: { animation: 'isLeft' }, canActivate: [AdminGuard] },

      { path: 'forgotpass', loadChildren: () => import('./forgot-pass/forgot-pass.module').then(m => m.ForgotPassModule) },
      { path: 'payments/:id1/:id2/:id3', loadChildren: () => import('./payments/payments.module').then(m => m.PaymentsModule), canActivate: [AuthGuard] },
      { path: 'progress/:id1/:id2/:id3', loadChildren: () => import('./progress/progress.module').then(m => m.ProgressModule), canActivate: [ProgressGuard] },
      { path: '', redirectTo: '/login', pathMatch: 'full' },
      // { path: '**', redirectTo: '/login' },
      { path: '404', component: NotFoundComponent },
      { path: '**', component: NotFoundComponent }


    ], { useHash: false }),

   // UserIdleModule.forRoot({ idle: 60, timeout: 300, ping: 120 }),

    //NgxStripeModule,
    // Third-party
    
  ],

  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,    
    
    AllUsersComponent,  
    LoginComponent, 
    AdminDialogComponent,
    SideNavComponent, AdminSideComponent, UserSideComponent, NotFoundComponent, ManagerSideComponent, YesNoComponent
       
    
  ],
  
  providers: [UserService, AuthService, { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },],
    
    bootstrap: [AppComponent],
    entryComponents: [AdminDialogComponent,YesNoComponent]  //for MatDialog AdminDialogComponent
})
export class AppModule {

}
